export default "__VITE_ASSET__BCxgxTdt__"